import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SaveService } from '../shared/services/save.service';
import { Institution } from '../shared/model/institution';
import { InstitutionsService } from '../shared/services/institutions.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-student-dashboard',
  templateUrl: './student-dashboard.component.html',
  styleUrls: ['./student-dashboard.component.css']
})
export class StudentDashboardComponent implements OnInit {
  nbfavorite: number;

  constructor(private router: Router,
    private saveService: SaveService,
    private institutionsService: InstitutionsService) { }

  userInstitution: Institution[] = [];

  ngOnInit() {
    this.saveService.setTitle("Ma console")
    this.getData();
  }

  getData = () => {
    console.log("getData")
    if (this.saveService.getUser()) {
      this.saveService.getUser().favoriteInstitution
        .map((id, index) => {
          this.nbfavorite = index;
          if (index !== 0) {
            this.institutionsService.findInstitutionById(id.institution)
              .subscribe(institution => this.userInstitution.push(institution))
          }
        });
    }
  }

  mesOptions = () => {
    this.router.navigate(['choice-student'])
  }

  refresh = () => {
    this.userInstitution = [];
    this.getData();
  }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/student-dashboard/student-dashboard.component.ts